import img from "../../img/Logo.svg";
import plus from "../../img/+.svg";
import { ContainerDash, DashForm, Tech, User } from "./styles";
import { api } from "../../services/api";

import { useHistory, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { Card } from "../../components/Card";

export const Dashboard = ({ onClick, openEditModal }) => {
  const history = useHistory();
  const { id } = useParams();
  const [techs, setTechs] = useState([]);
  const token = localStorage.getItem("@Kenzie_Hub_USER_TOKEN");
  const { name, course_module } = useParams();

  useEffect(() => {
    api
      .get(`/users/${id}`)
      .then((res) => {
        setTechs(res.data.techs);
      })
      .catch((err) => toast.error("Ops! Algo deu errado"));
  }, [techs]);

  const LeaveBtn = () => {
    history.push("/");
  };
  const deleteCard = (id) => {
    api
      .delete(`/users/techs/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        console.log(res);
      })
      .catch((err) => console.log(err));
  };

  return (
    <ContainerDash>
      <header>
        <figure>
          <img src={img} alt="add" />
        </figure>
        <button onClick={() => LeaveBtn()}>Sair</button>
      </header>
      <User>
        <h1>Olá, {name}</h1>
        <p>{course_module}</p>
      </User>

      <Tech>
        <h2>Tecnologias</h2>
        <figure onClick={onClick}>
          <img src={plus} alt="logo" />
        </figure>
      </Tech>
      <DashForm>
        {techs.map((tech) => (
          <Card
            tech={tech}
            key={tech.id}
            deleteCard={deleteCard}
            openEditModal={openEditModal}
          ></Card>
        ))}
      </DashForm>
    </ContainerDash>
  );
};
